<template>
   <div>
    <div class="unpublish-card" v-for="(item, index) in  list" :key="index">
        <div class="top">
            <div class="title"> {{item.title}}</div>
            <div class="tag">
                <p style="width: 36px;">草稿</p>
                <p style="border:1px solid rgba(254,183,5,1);color:rgba(254,183,5,1);">审核中</p>
                <p style="border:1px solid rgba(231,0,18,1);color:rgba(231,0,18,1);">未过审</p>
            </div>
           
        </div>
        <div class="content">
            {{item.content}}
        </div>
        <div class="btns">
            <div class="btn">
                <diV class="edit-icon"></diV>
                <p>编辑</p>
            </div>
            <div class="btn">
                <diV  class="del-icon"></diV>
                <p>删除</p>
            </div>
            <div class="btn">
                <diV  class="share-icon"></diV>
                <p>撤回</p>
            </div>
            <div class="time">
                {{item.time}}
            </div>
        </div>
    </div>
  </div>
</template>
<script>
export default {
    name:'unpublish-card',
    data(){
        return{
            list:[
                {
                    title:'如何设计—— 场卓有成效的访谈',
                    content:'每一年的苹果春节发布会都是科技迷们的一次朝圣大会，苹果从第一代iPhone开始就为自己奠定了科技潮流标杆的地位，在目前各大手机厂商都开始 把硬件做到极致的时候，我们也在期待着苹果还会给我们，每一年的苹果春节发布会都是科',
                    time:' 2019-03-01',
                
                },
                 {
                    title:'如何设计—— 场卓有成效的访谈',
                    content:'每一年的苹果春节发布会都是科技迷们的一次朝圣大会，苹果从第一代iPhone开始就为自己奠定了科技潮流标杆的地位，在目前各大手机厂商都开始 把硬件做到极致的时候，我们也在期待着苹果还会给我们，每一年的苹果春节发布会都是科',
                    time:' 2019-03-01',
                
                },
                 {
                    title:'如何设计—— 场卓有成效的访谈',
                    content:'每一年的苹果春节发布会都是科技迷们的一次朝圣大会，苹果从第一代iPhone开始就为自己奠定了科技潮流标杆的地位，在目前各大手机厂商都开始 把硬件做到极致的时候，我们也在期待着苹果还会给我们，每一年的苹果春节发布会都是科',
                    time:' 2019-03-01',
                
                },
            ],
        }
    }
}
</script>

<style lang="scss" scoped>
   .unpublish-card{
       width: 850px;
       height: 100%;
       border-bottom: 1px solid rgba(234,234,234,1);
       padding-top: 26px;
       padding-bottom: 27px;
        >.top{
             display: flex;
             flex-direction: row;

            >.title{
                font-size:18px;
                font-family:MicrosoftYaHei-Bold;
                font-weight:bold;
                color:rgba(51,51,51,1);
                line-height:24px;
                text-align: left;
            }
            >.tag{
                display: flex;
                flex-direction: row;
                height: 24px;
                padding-top: 7px;
               >p{
                    margin: 0;
                    width: 48px;
                    margin-left: 12px;
                    height: 15px;
                    color:rgba(153,153,153,1);
                    border-radius:2px;
                    border:1px solid rgba(153,153,153,1);
                }
            }
          
            
        }
        >.content{
            width:850px;
            height:100%;
            font-size:13px;
            font-family:MicrosoftYaHei;
            color:rgba(153,153,153,1);
            line-height:24px;
            text-align: left;
            padding-top: 8px;
        }
        >.btns{
                width: 100%;
                // display: flex;
                // flex-direction: row;
                height: 20px;
                margin-top: 5px;
            >.btn{
                width: 50px;
                margin-right: 30px;
                // display: flex;
                // flex-direction: row;
                float: left;
               >.edit-icon{
                width: 20px;
                height: 20px;
                background-size: cover;
                background-image: url('~@/assets/img/useredit.png');
                float: left;
                
               }
                >.del-icon{
                width: 20px;
                height: 20px;
                background-size: cover;
                background-image: url('~@/assets/img/del.png');
                float: left;
               }
                >.share-icon{
                width: 20px;
                height: 20px;
                background-size: cover;
                background-image: url('~@/assets/img/share.png');
                float: left;
               }
              >p{
                   text-align: left;
                   font-size:12px;
                    font-family:MicrosoftYaHei-Bold;
                    font-weight:bold;
                    color:rgba(153,153,153,1);
                    line-height:16px;
                    padding-top: 3px;
                    margin: 0;
              }
               


            }
            >.time{
               font-size:12px;
                font-family:MicrosoftYaHei;
                color:rgba(153,153,153,1);
                line-height:16px;
                padding-top: 3px;
                float: right;
            }
            

        }
   }
</style>
